import React, { useEffect, useState} from 'react';
import { FullCalendar} from 'ui'
import {EventClickArg} from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from "@fullcalendar/interaction"
import CalendarEventModal from 'components/Resources/CalendarEventModal'
import {useResource} from "../../../hooks/Resources/useResource";
import ResourceReservationFilterModal from "../ResourceResevationFilterModal";
import { useIntl} from "react-intl";
import {Tooltip} from "antd";

const ResourcesCalendar: React.FC = () => {
    const [showCreateModal, setCreateModal] = useState<boolean>(false);
    const [showFilterModal, setShowFilterModal] = useState<boolean>(false);
    const [showEventModal, setShowEventModal] = useState<boolean>(false);
    const [eventData, setEventData] = useState<any | null>(null);
    const [refetchEvents, setRefetchEvents] = useState<boolean>(false);
    const [reservationData, setReservationData] = useState<any | null>(null);
    const [events, setEvents] = useState<any[]>([]);
    const [filter, setFilter] = useState<string>('');
    const [dateRange, setDateRange] = useState<{ start: string; end: string } | null>(null);
    const { getCalendarResourceReservations } = useResource();
    const intl = useIntl();

    useEffect(() => {
        if (!dateRange) return;
        const fetchResources = async () => {
            const response = await getCalendarResourceReservations({
                start: dateRange.start,
                end: dateRange.end,
                filter,
            });
            setEvents(response ?? []);
        }

        fetchResources();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dateRange, filter, refetchEvents])

    const handleDatesSet = (arg: any) => {
        setDateRange({ start: arg.startStr, end: arg.endStr });
    }

    useEffect(() => {
        if (!showEventModal) {
            setReservationData(null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showEventModal])

    useEffect(() => {
        if (!!reservationData) {
            setShowEventModal(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [reservationData])


    const handleDateClick = (day: any) => {
        setReservationData({
            day
        });
    }

    const handleEventClick = (clickInfo: EventClickArg) => {
        if (clickInfo.event.extendedProps.hasSession) {
            return;
        }

        if (clickInfo.event.extendedProps.isEvent) {
            setEventData({
                id: Number(clickInfo.event.id),
                title: clickInfo.event.title,
                resourceId: clickInfo.event.extendedProps.resourceId,
                description: clickInfo.event.extendedProps.description,
                color: clickInfo.event.backgroundColor || clickInfo.event.extendedProps.color,
                start: clickInfo.event.start,
                end: clickInfo.event.end,
            });
            setShowEventModal(true);
            return;
        }

        setReservationData({
            id: clickInfo.event.id,
            resourceId: clickInfo.event.extendedProps.resourceId,
            start: clickInfo.event.start,
            end: clickInfo.event.end,
        });
    }

    const handleAddReservation = () => {
        setShowEventModal(false);
        setRefetchEvents(!refetchEvents);
    }

    const handleEventModalSubmit = () => {
        setShowEventModal(false);
        setEventData(null);
        setRefetchEvents(!refetchEvents);
    }

    const handleEventModalCancel = () => {
        setShowEventModal(false);
        setEventData(null);
    }

    const handleAddEventClick = () => {
        setEventData({});
        setShowEventModal(true);
    }

    const renderEventContent = (eventInfo: any) => {
        return (
            <>
                <Tooltip className={'flex align-center w-100'}  placement="top" title={eventInfo.event.extendedProps.sessionTitle}>
                    <div className='fc-daygrid-event-dot' style={{borderColor: eventInfo.backgroundColor}}></div>
                    <div className={'fc-event-time'}>{eventInfo.timeText} </div>
                    <div className={'fc-event-title'}>{eventInfo.event.title}</div>
                </Tooltip>
            </>
        )
    }

    return <>
        <FullCalendar
            refetchEvents={refetchEvents}
            nowIndicator={true}
            allDaySlot={false}
            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
            customButtons={{
                myCustomButton: {
                    text: intl.formatMessage({id:'general.filter'}),
                    click: function() { setShowFilterModal(true) }
                },
                addEventButton: {
                    text: intl.formatMessage({id:'system.resource.calendar.add_event'}),
                    click: handleAddEventClick
                }
            }}
            headerToolbar={{
                left: 'prev,next today myCustomButton addEventButton',
                center: 'title',
                right: 'dayGridMonth,timeGridWeek,timeGridDay'
            }}
            initialView="dayGridMonth"
            dateClick={handleDateClick}
            eventClick={handleEventClick}
            eventContent={renderEventContent}
            events={events}
            datesSet={handleDatesSet}
        />
          <ResourceReservationFilterModal visible={showFilterModal} onCancel={setShowFilterModal} onApply={setFilter}/>
          {showEventModal && <CalendarEventModal
              visible={showEventModal}
              onCancel={handleEventModalCancel}
              onSubmit={handleEventModalSubmit}
              reservationData={reservationData}
              eventData={eventData}
          />}
    </>;
};

export default ResourcesCalendar;